module.exports = __webpack_public_path__ + "img/icon-bookmark-outline.e23c8ea.svg";